<template>
  <Select :value="value" @input="handleInput" :label="label" :options="options" :isVerific="false" :placeholder="placeholder" :startVerific="false" />
</template>
<script>
import Select from '../Select/select.vue';
import OPTIONS from './options';
export default {
  name: 'CardType',
  components: {
    Select
  },
  props: {
    value: {
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    label: {
      type: String,
      default: '证件类型'
    }
  },
  data: () => ({
    options: OPTIONS
  }),
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    }
  }
};
</script>
